import { useCallback, useEffect, useRef, useState } from 'react';

function useLayoutNavigationState(location, navigationType) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
    const navigationActionRef = useRef({ key: location.key, action: navigationType });
    const accountMenuRef = useRef(null);

    useEffect(() => {
        navigationActionRef.current = { key: location.key, action: navigationType };
    }, [location.key, navigationType]);

    useEffect(() => {
        setIsMenuOpen(false);
        setIsAccountMenuOpen(false);

        const { key, action } = navigationActionRef.current;
        const normalizedPath = location.pathname.toLowerCase();
        const shouldSkipCatalogScrollReset =
            normalizedPath === '/games' ||
            normalizedPath === '/games/' ||
            normalizedPath.startsWith('/games/');

        if (key === location.key && (action === 'PUSH' || action === 'REPLACE') && !shouldSkipCatalogScrollReset) {
            window.scrollTo(0, 0);
        }
    }, [location]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (accountMenuRef.current && !accountMenuRef.current.contains(event.target)) {
                setIsAccountMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleMenu = useCallback(() => {
        setIsMenuOpen((prev) => !prev);
    }, []);

    const closeMenu = useCallback(() => {
        setIsMenuOpen(false);
    }, []);

    const toggleAccountMenu = useCallback(() => {
        setIsAccountMenuOpen((prev) => !prev);
    }, []);

    const closeAccountMenu = useCallback(() => {
        setIsAccountMenuOpen(false);
    }, []);

    return {
        isMenuOpen,
        isAccountMenuOpen,
        toggleMenu,
        closeMenu,
        toggleAccountMenu,
        accountMenuRef,
        closeAccountMenu,
    };
}

export default useLayoutNavigationState;
